import { render } from "./TestForm.vue?vue&type=template&id=55d7a242"
import script from "./TestForm.vue?vue&type=script&lang=ts"
export * from "./TestForm.vue?vue&type=script&lang=ts"
script.render = render

export default script